/* eslint-disable import/default */

import React from "react";
import { createHistory } from "history";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { Router, useRouterHistory } from "react-router";
import { getRoutes } from "./components/app/routes";
import store from "./store";
require("./favicon.ico");
import { syncHistoryWithStore } from "react-router-redux";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/toastr/build/toastr.min.css";
import "../node_modules/fixed-data-table/dist/fixed-data-table-base.min.css";

import "../node_modules/react-select/dist/react-select.css";
import "../node_modules/react-virtualized/styles.css";
import "../node_modules/react-virtualized-select/styles.css";

import "./assets/styles/styles.scss";

import keycloakManager from "./components/login/sso/keycloakManager";
import { getSessionCookies } from "./components/common/sessions/tokenHelper";

const browserHistory = useRouterHistory(createHistory)({
  basename: "/",
});
const history = syncHistoryWithStore(browserHistory, store);

const [accessToken, refreshToken] = getSessionCookies();
if (accessToken && refreshToken)
  keycloakManager.initiate(accessToken, refreshToken, renderApp);
else
  renderApp();

function renderApp() {
  render(
    <Provider store={store}>
      <Router history={history}>{getRoutes(store)}</Router>
    </Provider>,
    document.getElementById("app")
  );
}



// WEBPACK FOOTER //
// ./src/index.js